import { render } from "./EnrolleeDownloadComponent.vue?vue&type=template&id=48d0ded2&scoped=true"
import script from "./EnrolleeDownloadComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeDownloadComponent.vue?vue&type=script&lang=js"

import "./EnrolleeDownloadComponent.vue?vue&type=style&index=0&id=48d0ded2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d0ded2"]])

export default __exports__